import { BasicUserWithPermissions } from 'App/resources/Model/User';

/**
 * Lang tag to qualify a ticket assignee with, or null when the assignee is an ordinary support
 * user. An assignee who cannot be picked from the assignee dropdown is not necessarily inactive
 * — they may just lack a support licence — so the two cases get separate labels.
 *
 * `allActiveUsers` must be the unfiltered active-user list (`useUsers('active', false, 'all')`).
 * Passing a support-filtered list makes every unlicensed assignee read as inactive, which is the
 * mislabel this helper exists to prevent (WEB-10214).
 */
export const getTicketAssigneeLangTag = (
	user: { id: number } | null | undefined,
	allActiveUsers: BasicUserWithPermissions[]
): 'default.inactive' | 'ticket.noSupportAccess' | null => {
	if (!user) {
		return null;
	}
	const activeUser = allActiveUsers.find(u => u.id === user.id);
	if (!activeUser || activeUser.ghost) {
		return 'default.inactive';
	}
	return activeUser.support ? null : 'ticket.noSupportAccess';
};
